
import RelatedArticle from "./RelatedArticle";

export default {
  components: { RelatedArticle },

  props: { fields: { type: Array, default: () => {} } },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        slidesPerGroup: 1,
        slidesPerView: "auto",
        loop: false,
        loopFillGroupWithBlank: false,
      };
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.m-list-of-artilces", this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(".swiper.m-list-of-artilces");
  },
};
